<template>
  <PageWrapper>
    <template>
      <Tabs :tabs="tabs">
        <template #tab-0>
          <GeneralInformationTab
            :loading="loading"
            @getTermData="getTermData"
          />
        </template>
        <template #tab-1>
          <RegisterTypeTab @getTermData="getTermData" />
        </template>
        <template #tab-2>
          <TermStateTab />
        </template>
        <template #tab-3>
          <FurtherInformationTab @getTermData="getTermData" />
        </template>
        <template #tab-4>
          <AttachmentsTab @getTermData="getTermData" />
        </template>
        <template #tab-5>
          <TermProfileCheckboxTab />
        </template>
      </Tabs>
    </template>
  </PageWrapper>
</template>

<script>
import PageWrapper from "@/components/re-design/wrappers/PageWrapper.vue";
import Tabs from "@/components/re-design/tabs/Tabs.vue";
import GeneralInformationTab from "./components/GeneralInformationTab.vue";
import RegisterTypeTab from "./components/RegisterTypeTab.vue";
import FurtherInformationTab from "./components/FurtherInformationTab.vue";
import AttachmentsTab from "./components/AttachmentsTab.vue";
import TermStateTab from "./term-state/TermStateTab.vue";
import TermProfileCheckboxTab from "./components/TermProfileCheckboxTab.vue";
import { pathOr } from "ramda";
import {
  generateCurrentRoute,
  generateError,
  generateLang,
  storeDispatcher,
} from "@/shared/utils";
import { computed, onMounted, provide, ref } from "vue";
import { getTerm } from "@/modules/profile/services";

export default {
  components: {
    PageWrapper,
    Tabs,
    GeneralInformationTab,
    RegisterTypeTab,
    FurtherInformationTab,
    AttachmentsTab,
    TermStateTab,
    TermProfileCheckboxTab,
  },
  setup() {
    const tabs = ref([
      "اطلاعات کلی",
      "نحوه ثبت نام",
      "مراحل دوره",
      "اطلاعات تکمیلی",
      "پیوست ها",
      "نمایه دوره",
    ]);

    const termCode = generateCurrentRoute(["params", "code"]);
    provide("TERM_CODE", termCode);

    const setPageTitle = (data) => {
      const termCaption = pathOr(null, ["caption"], data);
      const title = `${generateLang(["editTerm"])} <span class="margin-right-4">${termCaption}</span>`;
      storeDispatcher("mobileHeaderTitleText", title);
    };

    const loading = ref(false);
    const termData = ref(null);
    const getTermData = async () => {
      try {
        loading.value = true;
        const response = await getTerm(termCode);
        termData.value = response;
        setPageTitle(termData.value);
      } catch (error) {
        generateError(error);
      } finally {
        loading.value = false;
      }
    };
    onMounted(() => getTermData());

    // provide term data to child components
    provide(
      "TERM_DATA",
      computed(() => termData.value)
    );

    // return data to be used in template
    return { tabs, loading, getTermData };
  },
};
</script>
